var groupTitle = 'fx_2d2fb1e5_1pkk9kc0';

export { groupTitle };
//# sourceMappingURL=groupTitle.vanilla.mjs.map
